var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M102.246 175.486L43.1855 166.381L53.3706 89.9014L112.44 98.9465L89.8455 42.5015L160.221 14.2919L182.869 70.7153L219.337 23.3753L279.527 71.6452L243.106 119.023L302.168 128.128L291.982 204.608L232.914 195.563L255.508 252.007L185.132 280.217L162.484 223.794L126.016 271.134L65.8262 222.864L102.246 175.486Z","fill":"#669F71"}));
}

Star.defaultProps = {"width":"0","height":"0","viewBox":"0 0 346 321","fill":"none","id":"star","className":"shape"};

module.exports = Star;

Star.default = Star;
